import { render, staticRenderFns } from "./LandingWishlistES.vue?vue&type=template&id=e9f5e998&scoped=true"
import script from "./LandingWishlistES.vue?vue&type=script&lang=js"
export * from "./LandingWishlistES.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e9f5e998",
  null
  
)

export default component.exports